import { Box, Button } from '@mui/material'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import { appendToUrl, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import * as id from '../reportId'
import * as lb from '../reportLables'
import * as reportUrls from '../oldReportsUrls'
import moment from 'moment/moment'
import { paymentModeAll, urls } from '../../../common/constants'
import { paymentModesWithAll } from '../../../common/paymentsMode'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest, GetRequestCachedV3 } from '../../../common/api'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import DropDownMultiSelectV2 from '../../../common/dropDownMultiSelectV2'
import LoaderModel from './loaderModel'
import { buildUWCCriteriaHeaders, buildUWCCriteriaData, transformDetailedData, transformSummaryData, getSummaryGrandNet, } from './UserWiseCollectionUtils'
import { getcolumnDefs, summaryColumnDefs } from './constants'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'
import { TOPAY_AS_COD_HEADER_MAP } from '../userWiseCollReport/constants'
import { getDecryptedReportParams } from '../../../common/loginDecode'

const transactionsData = [
    { Transactions: 'All', transactionId: 0 },
    { Transactions: 'Booking', transactionId: 1 },
    { Transactions: 'Delivery', transactionId: 2 },
    { Transactions: 'Refund', transactionId: 3 },
]
const ModesData = [0, 'B', 'D', 'R']
const reportViewData = [
    { view: 'Detailed', id: 0 },
    { view: 'Summary', id: 1 },
]

const UserWiseCollectionWithDeliveryExpense = () => {
    const setLoader = useSetAtom(globalLoaderAtom)
    const setAlert = useSetAtom(alertAtom)
    const [modal, setModal] = useAtom(modalAtom)
    const common = useSelector((state) => state.common)
    const reports = useSelector((state) => state.reports)
    const { cargoSettingFilterData } = reports

    const [fromDate, setFromDate] = useState(moment())
    const [toDate, setToDate] = useState(moment())
    const [selBranch, setSelBranch] = useState()
    const [selUser, setSelUser] = useState([])
    const [userStatusList, setUserStatusList] = useState([])
    const [transaction, setTransaction] = useState(transactionsData[0])
    const [paymentType, setPaymentType] = useState(paymentModesWithAll[0])
    const [paymentMode, setPaymentMode] = useState(paymentModeAll)
    const [paymentModeData, setPaymentModeData] = useState([])
    const [reportView, setReportView] = useState(reportViewData[0])
    const [ownChildBranches, setOwnChildBranches] = useState([])
    const [ownChildUsers, setOwnChildUsers] = useState([])
    const [selCompany, setSelCompany] = useState(false)
    const [showTable, setShowTable] = useState(false)
    const [disableBtn, setDisableBtn] = useState(false)
    const [disableExcel, setDisableExcel] = useState(false)
    
    const [companySettings] = useAtom(companySettingsAtom)
    const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
    const { Table1: RoleRightTable1 = [] } = cargoRoleRights
    const [roleRightsData] = RoleRightTable1
    let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, AllowBranchInchargeRights, AllowExportExcel } = { ...roleRightsData }
    const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
    const UseFormattedLRinReports = companySettings?.UseFormattedLRinReports
    const UseToPayAsCOD = companySettings?.UseToPayAsCOD


    let { loginData = {} } = useToken()
    let isFromUrl = false
    if (!loginData) {
        loginData = {}
        loginData.intCompanyID = +searchParams.get('C') || 0
        loginData.intBranchCityID = +searchParams.get('CT') || 0
        loginData.intUserID = +searchParams.get('U') || 0
        loginData.intBranchID = +searchParams.get('B') || 0
        loginData.strUserName = searchParams.get('UN') || ''
        loginData.strCompanyName = searchParams.get('CN') || ''
        loginData.strBranchName = searchParams.get('BN') || ''
        AllowViewAllBranchOfCityReport = +searchParams.get('AllowViewAllBranchOfCityReport') || 0
        AllowViewAllBranchReport = +searchParams.get('AllowViewAllBranchReport') || 0
        AllowBranchInchargeRights = +searchParams.get('AllowBranchInchargeRights') || 0
        isFromUrl = true
    }

    const { intCompanyID, IsAdmin, intBranchID, intBranchCityID, intUserID, strCompanyName, IsBranchAdmin, strBranchName, IsMTPLAdmin, BusCrsCheckSum } = loginData

    const reportName = 'User Wise Collection With Expense'

    useEffect(() => { focusElemnt('UWFromDate') }, [])

    useEffect(() => {
        if (!isEmpty(roleRightsData) && intUserID) {
            setDisableBtn(!(AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin))
            setDisableExcel(!AllowExportExcel)
        }
    }, [roleRightsData, intUserID])

    useEffect(() => {
        if (!intUserID) return
        setSelCompany(strCompanyName)
        const body = { intUserID, intCompanyID, intIsActive: -1 }
        const fetchData = async () => {
            setLoader(true)
            const [branchRes, userRes] = await Promise.all([
                GetRequestCachedV3(urls.getOwnAndChildBranchList, body, true, 24 * 60 * 60 * 1000),
                GetRequestCachedV3(urls.getOwnAndChildUsersList, body, true, 24 * 60 * 60 * 1000),
            ])
            setLoader(false)
            if (branchRes?.status === 'Success' && branchRes?.Data?.Table?.length > 0) {
                setOwnChildBranches(branchRes.Data.Table)
                setSelBranch(branchRes.Data.Table.find(v => v.BranchID === intBranchID) || branchRes.Data.Table[0])
            } else setAlert({ show: true, msg: branchRes?.ErrMessage })
            if (userRes?.status === 'Success' && userRes?.Data?.Table?.length > 0) {
                setOwnChildUsers(userRes.Data.Table)
                setSelUser(userRes.Data.Table.filter(v => v.UserID === intUserID) || [])
            } else setAlert({ show: true, msg: userRes?.ErrMessage })
        }
        fetchData()
    }, [intUserID])

    useEffect(() => {
        if (!selBranch?.BranchID) return
        const fetchPaymentModes = async () => {
            setLoader(true)
            const res = await GetRequestCachedV3(urls.getMOFPayment, { intBranchID: selBranch.BranchID }, true, 24 * 60 * 60 * 1000)
            setLoader(false)
            if (res?.status === 'Success' && res?.Data?.Table?.length > 0) {
                setPaymentModeData([paymentModeAll, ...res.Data.Table])
            } else setAlert({ show: true, msg: res?.ErrMessage })
        }
        fetchPaymentModes()
    }, [selBranch?.BranchID])

    useEffect(() => {
        setUserStatusList(selUser.map(v => ({ loaded: 0, data: [], UserID: v.UserID, UserName: v.UserName })))
    }, [selUser])

    const availableUsers = [
        { UserName: 'All Users', UserID: 0 },
        ...ownChildUsers?.filter(v => v?.BranchID === selBranch?.BranchID && v?.IsUserActive) || []
    ]

    const getMainHeader = (columns = []) =>
        columns.map(col => {
            const header = col.headerName || col.header || ''
            return {
                ...col,
                header,
                exportHead: col.exportHead || header,
                align: col?.xlCol?.dataType === 'string' ? 'left' : 'right' || col.align || 'left',
                weight: col?.weight ?? 80,
            }
        })

    const getReportData = async (data, UseToPayAsCOD) => {
    const res = await GetRequest(urls.getUserWiseCollection, data)

    if (res?.status !== 'Success') {
      setAlert({
        show: true,
        msg: res?.ErrMessage,
      })
      return null
    }

    if (UseToPayAsCOD !== 1) {
      return res.Data
    }
    return {
      ...res.Data,
      Table: res.Data.Table.map((item) => ({
        ...item,
        TYPE: item.TYPE === 'TO PAY' ? 'COD' : item.TYPE,
      })),
    }
  }

    const buildRequest = (UserID) => ({
        CompanyID: intCompanyID,
        BranchID: selBranch?.BranchID,
        UserID,
        dtFrom: moment(fromDate).format('YYYY-MM-DD'),
        dtTo: moment(toDate).format('YYYY-MM-DD'),
        PaymentTypeIDs: paymentType?.typeId,
        Modes: ModesData[transaction?.transactionId],
        PaymentModeIDs: paymentMode?.ModeID,
    })

    const getReportUserDetail = (reportData) => {
        if (Array.isArray(reportData?.Table2) && reportData.Table2.length > 0) return reportData.Table2
        return [{
            Branchname: selBranch?.BranchName || '',
            Cityname: selBranch?.Cityname || selBranch?.CityName || '',
            Statename: selBranch?.Statename || selBranch?.StateName || '',
        }]
    }
    const normalizeTableData = (rows = []) =>
        rows.map(row => row?.dataType === 'header2' ? { ...row, dataType: 'header', disableSortIcon: true } : row)

    const getSummaryColumns = (columns = []) => {
        if (UseToPayAsCOD !== 1) return columns
        return columns
          .filter((column) => column.field !== 'CODAmt')
          .map((column) => ({
            ...column,
            headerName: TOPAY_AS_COD_HEADER_MAP[column.field] ?? column.headerName,
          }))
    }
    const getReportPayload = (reportData) => {
        const UserName = selUser.length === 1 ? selUser[0].UserName : 'All'
        const userDetail = getReportUserDetail(reportData)
        const { Table, Table1, Table3 } = reportData
        const isDetailed = reportView?.id === 0
        const grandNet = getSummaryGrandNet(Table1)
        const filteredHeaders = getSummaryColumns(summaryColumnDefs).filter((col) => {
          if (['Transaction', 'TotalAmt', 'PaidAmt', 'TopayAmt', 'OnAccAmt'].includes(col.field)) {
            return true
          }
          return grandNet[col.field] !== 0
        })
        return {
            reportName: `Userwise Collection With Expense (${isDetailed ? 'Detailed' : 'Summary'})`,
            criteriaHeaders: buildUWCCriteriaHeaders(),
            criteriaData: [buildUWCCriteriaData({ selBranch, selUser, fromDate, toDate, transaction, paymentType, paymentMode, reportView })],
            mainHeader: getMainHeader(isDetailed ? getcolumnDefs(UseFormattedLRinReports) : filteredHeaders),
            tableData: normalizeTableData(isDetailed
                ? transformDetailedData(Table, userDetail, Table3, UserName, UseFormattedLRinReports, cargoSettingFilterData)
                : transformSummaryData(Table1, userDetail, UserName, filteredHeaders)),
            colSpanMarker: isDetailed ? 'UserName' : 'Transaction',
            hideHeader: true,
            totalSubKey: 4,
            serialNokey: 'SN',
        }
    }

    const openViewReport = (reportPayload, isPdf = false) => {
        if (isPdf) {
            downloadPDF({
                reportName: reportPayload.reportName,
                criteriaHeaders: reportPayload.criteriaHeaders,
                criteriaData: reportPayload.criteriaData,
                tableData: reportPayload.tableData,
                visibleColumns: reportPayload.mainHeader,
                loginData,
                hideHeader: reportPayload.hideHeader || false,
            })
            return
        }
        const rid = Date.now().toString()
        if (!window.generatedReports) window.generatedReports = {}
        window.generatedReports[rid] = reportPayload
        window.open(`/view-report?rid=${rid}`, '_blank')
    }

    const validateFilters = () => {
        const diffDays = Math.abs(toDate.diff(fromDate, 'days'))

        // if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
        //     setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days' })
        //     return false
        // }
        if (!selBranch?.BranchID) {
            setAlert({ show: true, msg: 'Select Branch' })
            return false
        }
        if (!selUser?.length) {
            setAlert({ show: true, msg: 'Select Company User' })
            return false
        }
        if (selUser.length === 1 && diffDays > 31) {
        setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: ''})
        return false
        }

        if (selUser.length > 1 && diffDays > 15) {
        setAlert({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: ''})
        return false
        }
        return true
    }

    const handleClick1 = async (isPdf = false) => {
        if (!validateFilters()) return

        if (selUser.length === 1 || selUser[0].UserID === 0) {
            setLoader(true)
            const reportData = await getReportData(buildRequest(selUser[0].UserID), UseToPayAsCOD)
            setLoader(false)
            if (!reportData.Table?.length && !reportData.Table1?.length) {
                setAlert({ show: true, msg: 'No data found for the selected criteria' })
                return
            }
            if (reportData) openViewReport(getReportPayload(reportData), isPdf)
            return
        }

        setModal('loaderModal')
        const reportDataList = []

        for (const user of selUser) {
            setUserStatusList(prev => prev.map(item => item.UserID === user.UserID ? { ...item, loaded: 1 } : item))
            const reportData = await getReportData(buildRequest(user.UserID), UseToPayAsCOD)
            setUserStatusList(prev => prev.map(item => item.UserID === user.UserID ? { ...item, loaded: 2 } : item))
            reportDataList.push(reportData)
        }

        setModal()

        const merged = reportDataList.reduce(
            (acc, curr) => {
                if (curr?.Table) acc.Table.push(...curr.Table)
                if (curr?.Table1) acc.Table1.push(...curr.Table1)
                if (curr?.Table3) acc.Table3.push(...curr.Table3)
                return acc
            },
            { Table: [], Table1: [], Table3: [] }
        )

        const Table3Sum = merged.Table3.reduce(
            (acc, item) => {
                acc.TotalConvCharge += parseFloat(item.TotalConvCharge) || 0
                acc.TotalLRs += parseFloat(item.TotalLRs) || 0
                acc.TotalUnis += parseFloat(item.TotalUnis) || 0
                acc.DailyExpense += parseFloat(item.DailyExpense) || 0
                return acc
            },
            { TotalConvCharge: 0, TotalLRs: 0, TotalUnis: 0, DailyExpense: 0 }
        )

        const Table2 = reportDataList.find(r => Array.isArray(r?.Table2) && r.Table2.length)?.Table2 || []
        openViewReport(getReportPayload({ ...merged, Table2, Table3: [Table3Sum] }), isPdf)
    }

    const handleClick2 = () => {
        if (!validateFilters()) return
        const urlData = { ...reportUrls.userWiseCollectionParams }
        urlData.chk = BusCrsCheckSum
        urlData.FromDt = fromDate.format('YYYY-MM-DD')
        urlData.ToDt = toDate.format('YYYY-MM-DD')
        urlData.BranchID = selBranch.BranchID
        urlData.UserID = selUser[0]?.UserID || 0
        urlData.Summary = reportView?.id
        urlData.TransType = transaction.transactionId
        urlData.PaymentMode = paymentMode?.ModeID
        urlData.intCargoParentCompanyID = intCompanyID
        window.open(appendToUrl(reportUrls.userWiseCollection, urlData), '_blank')
    }

    const reset = () => {
        setFromDate(moment())
        setToDate(moment())
        setSelBranch({ BranchName: strBranchName, BranchID: intBranchID })
        setSelUser([])
        setTransaction(transactionsData[0])
        setPaymentType(paymentModesWithAll[0])
        setPaymentMode(paymentModeAll)
        setReportView(reportViewData[0])
    }

    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
                {!isFromUrl && <ReportHeading reportName={reportName} />}
                <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
                    {!isFromUrl && <>
                        <Item sx={sx.itemsxGrow}>
                            <DropDownOA
                                id={id.selectCompnay}
                                label={lb.select_company}
                                defaultvalue={selCompany}
                                disabled={true}
                                onSelect={(val) => {
                                    setSelCompany(val)
                                    setShowTable(false)
                                }}
                                width="100%"
                            />
                        </Item>
                        <Item sx={sx.itemsx} className="disabled-wrapper">
                            <Button
                                variant="contained"
                                disabled={true}
                                style={{ ...sx.fullHeight, ...sx.novp }}
                                id={id.goButton}
                                className="btn btn-primary"
                            >
                                GO
                            </Button>
                        </Item>
                    </>}
                    <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
                        <Datepicker
                            name={'from_collection_date'}
                            value={fromDate}
                            label={lb.from_collection_date}
                            id={'UWFromDate'}
                            dateChange={(date) => {
                                setFromDate(date)
                                setShowTable(false)
                                focusElemnt('UWToDate')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
                        <Datepicker
                            label={lb.to_collection_date}
                            value={toDate}
                            id={'UWToDate'}
                            dateChange={(date) => {
                                setToDate(date)
                                setShowTable(false)
                                focusElemnt(id.selBranch)
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            label={lb.select_branch}
                            id={id.selBranch}
                            data={
                                AllowViewAllBranchOfCityReport == 1 && AllowViewAllBranchReport == 0
                                    ? ownChildBranches.filter((val) => val.CityID == intBranchCityID)
                                    : ownChildBranches || []
                            }
                            defaultvalue={(ownChildBranches?.length > 0 && selBranch?.BranchName) || ''}
                            disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}
                            dataKey={`BranchName`}
                            idKey={`BranchID`}
                            onSelect={(val) => {
                                setSelBranch(val)
                                setShowTable(false)
                                setSelUser([])
                            }}
                            width="100%"
                            nextId={id.userLIst}
                            prevId={'UWToDate'}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownMultiSelectV2
                            id={id.userLIst}
                            label={'Branch User'}
                            defaultvalue={selUser}
                            data={availableUsers}
                            dataKey={`UserName`}
                            idKey={`UserID`}
                            onSelect={(list) => {
                                setSelUser(list)
                                setShowTable(false)
                            }}
                            nextId={'UWTransaction'}
                            prevId={id.selBranch}
                            width={isFromUrl ? '100%' : 'auto'}
                            disabled={disableBtn && AllowViewAllBranchOfCityReport === 0}
                        />
                    </Item>
                </Box>
                <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
                    <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '170px' }}>
                        <DropDownOA
                            id={'UWTransaction'}
                            defaultvalue={transaction?.Transactions}
                            data={transactionsData}
                            width="100%"
                            searchPlaceholder={`Search Transactions`}
                            label={'Transaction Type'}
                            tabIndex="2"
                            dataKey={`Transactions`}
                            idKey={`transactionId`}
                            onSelect={(value) => {
                                setTransaction(value)
                                setShowTable(false)
                            }}
                            nextId={'UWPaymentType'}
                            prevId={id.userLIst}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '175px' }}>
                        <DropDownOA
                            id="UWPaymentType"
                            data={paymentModesWithAll || []}
                            defaultvalue={paymentType?.name}
                            width="100%"
                            searchPlaceholder={`Search By Payment Type`}
                            label={'Payment Type'}
                            tabIndex="2"
                            dataKey={`name`}
                            idKey={`typeId`}
                            onSelect={(value) => {
                                setPaymentType(value)
                                setShowTable(false)
                            }}
                            nextId={'UWPaymentMode'}
                            prevId={'UWTransaction'}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '270px' }}>
                        <DropDownOA
                            id="UWPaymentMode"
                            data={paymentModeData}
                            defaultvalue={paymentModeData?.length > 0 && paymentMode?.ModeName}
                            width="100%"
                            searchPlaceholder={`Search By Payment Mode`}
                            label={'Payment Mode'}
                            tabIndex="2"
                            dataKey={`ModeName`}
                            idKey={`ModeID`}
                            onSelect={(value) => {
                                setPaymentMode(value)
                                setShowTable(false)
                            }}
                            nextId={'UWReportView'}
                            prevId={'UWPaymentType'}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '268px' }}>
                        <DropDownOA
                            id="UWReportView"
                            defaultvalue={reportView?.view}
                            data={reportViewData}
                            width="100%"
                            searchPlaceholder={`Search By View`}
                            label={'Report View'}
                            tabIndex="2"
                            dataKey={`view`}
                            idKey={`id`}
                            onSelect={(value) => {
                                setReportView(value)
                                setShowTable(false)
                            }}
                            nextId={'UWSplitButton'}
                            prevId={'UWPaymentMode'}
                        />
                    </Item>
                    {isFromUrl ?
                        <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={'UWSplitButton'}>
                            DOWNLOAD PDF
                        </Button> :
                        <>
                            <Item
                                sx={sx.itemsx}
                                style={{ cursor: 'pointer' }}
                                onKeyDown={(e) =>
                                    navigation3(e, showTable ? (disableExcel ? 'UWExpToPdfBtn' : 'UWExpToExsl') : 'UWFromDate', 'UWReportView', () =>
                                        handleClick1()
                                    )
                                }
                            >
                                <SplitButton
                                    options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                                    id1={'UWSplitButton'}
                                    prevID={id.summaryCheck}
                                    onClick1={() => handleClick1()}
                                    onClick2={handleClick2}
                                />
                            </Item>
                            <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
                                <RefreshSvg width={'24px'} height={'24px'} />
                            </Item>
                        </>}
                </Box>
            </Item>
            {modal === 'loaderModal' && <LoaderModel list={userStatusList} />}
        </>
    )
}
export default UserWiseCollectionWithDeliveryExpense